// extracted by mini-css-extract-plugin
module.exports = {"form":"Generate_form__Uwcxu"};